<script lang="ts">
  import { link } from "svelte-spa-router";
  import { CATEGORIES } from "../lib/categories";
  import { entries, byCategory, recentlyUpdated, activeCategories } from "../lib/content";
  import SopCard from "../lib/components/SopCard.svelte";
  import OnboardingProgress from "../lib/components/OnboardingProgress.svelte";

  $: total = $entries.length;
  $: present = activeCategories($entries);
  $: cats = CATEGORIES.filter((c) => present.includes(c.id)).sort((a, b) => a.order - b.order);
  $: recent = recentlyUpdated($entries, 14).slice(0, 4);
</script>

<div class="flex flex-col gap-8">
  <section class="flex flex-col gap-3">
    <div class="flex items-baseline gap-3 flex-wrap">
      <h1 class="text-3xl font-semibold tracking-tight">Agency Playbook</h1>
      <span class="text-text-muted">Everything you need to do the job here.</span>
    </div>
    <p class="text-text-muted max-w-2xl">
      One source of truth for how Legacy Growth Partners runs &mdash; from your first day, through every
      tool you'll touch, to the systems that make our delivery work.
    </p>
  </section>

  <OnboardingProgress />

  <section class="flex flex-col gap-3">
    <h2 class="text-sm uppercase tracking-wider text-text-dim">Categories</h2>
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {#each cats as cat}
        {@const count = byCategory($entries, cat.id).length}
        <a
          use:link
          href={`/category/${cat.id}`}
          class="panel p-5 hover:border-border-strong transition-colors flex flex-col gap-2"
        >
          <div class="flex items-center justify-between">
            <div class="text-base font-semibold text-text">{cat.label}</div>
            <span class="pill text-text-muted">{count}</span>
          </div>
          <div class="text-sm text-text-muted">{cat.description}</div>
        </a>
      {/each}
    </div>
  </section>

  {#if recent.length > 0}
    <section class="flex flex-col gap-3">
      <div class="flex items-baseline justify-between gap-3">
        <h2 class="text-sm uppercase tracking-wider text-text-dim">Recently updated</h2>
        <a use:link href="/changelog" class="text-xs text-text-muted hover:text-text">
          View changelog →
        </a>
      </div>
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {#each recent as sop}
          <SopCard {sop} />
        {/each}
      </div>
    </section>
  {/if}

  <div class="text-xs text-text-dim">
    {total} {total === 1 ? "entry" : "entries"} in the playbook ·
    <a use:link href="/search" class="hover:text-text">browse all</a>
  </div>
</div>
